export const hospitalPatientColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'address__address_string',
  'address__addressline1',
  'address__addressline2',
  'address__city',
  'address__postal_code',
  'address__postal_code_extension',
  'address__state',
  'birth_date',
  'death_date',
  'emergency_contact_first_name',
  'emergency_contact_last_name',
  'emergency_contact_phone',
  'emergency_contact_relationship',
  'employer',
  'employer_info__addressline1',
  'employer_info__addressline2',
  'employer_info__city',
  'employer_info__name',
  'employer_info__phone_number',
  'employer_info__postal_code',
  'employer_info__state',
  'enterprise_medical_record_number',
  'fk_hospital__guarantor_id',
  'fk_hospital__mother_id',
  'gender',
  'guarantor_email',
  'guarantor_id',
  'guarantor_race',
  'medical_record_number',
  'medicare_hic_number',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'name__first_name',
  'name__last_name',
  'name__middle_name',
  'name__name_prefix',
  'name__name_string',
  'name__name_suffix',
  'patient_email',
  'patient_height',
  'patient_home',
  'patient_id',
  'patient_marital_status',
  'patient_mobile',
  'patient_race',
  'patient_religion',
  'patient_weight',
  'patient_work',
  'phone_number',
  'snapshot_id',
  'ssn',
  'ucrn',
];
